module.exports = __webpack_public_path__ + "media/images/thumbnail_default-a3d1dd0b1037f3f486ca34806127cb11.png";